<template>
<main class="container">
<div id="content" class="text-center ">
 
<img src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif">
<h1>Error Code : 404</h1>
  <p>Page Not Found</p>
  <router-link to="/"><button class="btn btn-success">Go To Home</button></router-link>
 
  </div>
  </main>
  
</template>

<script>
export default {

}
</script>

<style scoped>
main{
    margin-top:0%;
}
#content{
  margin-top: -10%;
}
img{
  width: 100%;
}

h1{
  margin-top: -15%;
text-align: center;}
</style>